export const reportCheckboxes = [
  { name: 'openDate', label: 'Data de abertura do chamado' },
  { name: 'requesterName', label: 'Nome do solicitante' },
  { name: 'ownerName', label: 'Nome do proprietário' },
  { name: 'propertyCode', label: 'Código do imóvel' },
  { name: 'address', label: 'Endereço' },
  { name: 'providerNameCnpj', label: 'Nome/CNPJ da empresa prestadora' },
  { name: 'description', label: 'Descrição do chamado' },
  { name: 'budgetDescribed', label: 'Orçamento (descrito)' },
  { name: 'budgetItemsWithValues', label: 'Incluir itens com valores' },
  { name: 'timelineOpen', label: 'Evento de abertura de chamado' },
  { name: 'timelineBudgetReceived', label: 'Evento de orçamento recebido' },
  { name: 'timelineBudgetApproved', label: 'Evento de orçamento aprovado' },
  { name: 'timelineFinished', label: 'Evento de chamado finalizado' },
  { name: 'commentsPublic', label: 'Importar comentários (apenas públicos)' },
  { name: 'attachmentsOpen', label: 'Anexos da abertura do chamado' },
  { name: 'attachmentsFinished', label: 'Anexos da finalização de chamado' },
]
